import { useLocation, useMatch } from 'react-router-dom';
import { Layout, Navigation } from '@utilities';

import Page from '../Page';

interface SidebarInterface {
  children: React.ReactNode;
  route: Route;
}

const Sidebar = ({ children, route }: SidebarInterface) => {
  const { pathname: locationPathname } = useLocation();
  const match = useMatch('/dashboard/:type/*');

  const routes = route?.routes;

  const currentRoute = routes.find((route) => {
    let id = route?.path.split('/').pop();

    if (route?.path.includes('/:')) {
      id = route?.path.split('/').reverse()[1];
    }

    let pathname = locationPathname?.split('/').pop();

    if (route?.path.includes('/:')) {
      pathname = locationPathname?.split('/').reverse()[1];
    }

    return pathname === id;
  });

  return (
    <Page>
      <Layout.Column>
        <Layout.Flex>
          <Layout.Sidebar>
            <Navigation
              routes={routes?.map((route) => {
                return {
                  ...route,
                  to: `${match?.pathnameBase}/${route?.path}`,
                };
              })}
            />
          </Layout.Sidebar>
          <Layout.Fill>
            {currentRoute?.label && <h1>{currentRoute.label}</h1>}
            {children}
          </Layout.Fill>
        </Layout.Flex>
      </Layout.Column>
    </Page>
  );
};

export default Sidebar;
